var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("慢病管理可视化驾驶舱")]), _c('dir', {
    staticClass: "ctx flex"
  }, [_c('LeftPanel', {
    attrs: {
      "source": _vm.source
    }
  }), _c('div', {
    staticClass: "center flex1"
  }, [_c('CardPanel', {
    attrs: {
      "title": "患者各年龄段分配"
    }
  }, [_c('PatientDivision', {
    attrs: {
      "source": _vm.source,
      "id": _vm.id
    }
  })], 1), _c('CardPanel', {
    attrs: {
      "title": "评估周期统计"
    }
  }, [_c('EvalidateCycle', {
    attrs: {
      "source": _vm.source,
      "id": _vm.id
    }
  })], 1), _c('CardPanel', {
    attrs: {
      "title": "医保类别划分"
    }
  }, [_c('MIDivision', {
    attrs: {
      "source": _vm.source,
      "id": _vm.id
    }
  })], 1), _c('CardPanel', {
    attrs: {
      "title": "随访次数统计"
    }
  }, [_c('FollowUp', {
    attrs: {
      "source": _vm.source,
      "id": _vm.id
    }
  })], 1), _c('CardPanel', {
    attrs: {
      "title": "各种评估场景"
    }
  }, [_c('EvalidatePlace', {
    attrs: {
      "source": _vm.source,
      "id": _vm.id
    }
  })], 1), _c('CardPanel', {
    attrs: {
      "title": "预警指标统计"
    }
  }, [_c('dv-scroll-board', {
    attrs: {
      "config": _vm.idxsTable
    }
  })], 1)], 1), _c('div', {
    staticClass: "right w300 flex f-col"
  }, [_c('CardPanel', {
    staticClass: "flex1 kn-dict",
    attrs: {
      "title": "知识库统计"
    }
  }, [_c('KNDict', {
    attrs: {
      "source": _vm.source
    }
  })], 1), _c('CardPanel', {
    staticClass: "patientTable",
    attrs: {
      "title": "患者数据表"
    }
  }, [_c('dv-scroll-board', {
    attrs: {
      "config": _vm.patientTable
    },
    on: {
      "click": _vm.showPatientDetail
    }
  })], 1)], 1), _c('ElDialog', {
    attrs: {
      "visible": _vm.patientDetailVisible,
      "width": "100rem",
      "append-to-body": "",
      "center": "",
      "top": "5vh"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.patientDetailVisible = $event;
      }
    }
  }, [_c('div', {
    staticClass: "flex gap"
  }, [_c('div', {
    staticClass: "flex f-col gap",
    staticStyle: {
      "width": "32rem"
    }
  }, [_c('div', {
    staticClass: "info-card"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "report"
  })]), _vm._v(" 基础情况 ")]), _c('div', {
    staticClass: "infos"
  }, [_c('div', {
    staticClass: "flex row-between"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("身高")]), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.detail.height) + " cm")])]), _c('div', {
    staticClass: "flex row-between"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("体重")]), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.detail.weight) + " KG")])]), _c('div', {
    staticClass: "flex row-between"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("B M I")]), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.detail.bmi) + " kg/m2")])])])]), _c('div', {
    staticClass: "heart-card flex"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('div', {
    staticClass: "icon"
  }), _c('div', {
    staticClass: "tip"
  }, [_vm._v("心率")])]), _c('div', {
    staticClass: "heart-rate"
  }, [_vm._v(" 最近一次测量： "), _c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.detail.heartRate) + " ")]), _vm._v(" 次/分钟 ")])]), _c('div', {
    staticClass: "pressure flex1 flex f-col"
  }, [_c('div', {
    staticClass: "flex1 flex gap"
  }, [_c('Pressure', {
    attrs: {
      "num": _vm.detail.systolicPressure,
      "max": 200
    }
  }), _c('Pressure', {
    attrs: {
      "num": _vm.detail.diastolicPressure,
      "max": 130
    }
  })], 1), _c('div', {
    staticClass: "flex tips"
  }, [_c('span', [_vm._v("收缩压")]), _c('span', [_vm._v("舒张压")])]), _c('div', {
    staticClass: "pressure-tip"
  }, [_vm._v("血压")])])]), _c('div', {
    staticClass: "show-body flex1"
  }), _c('div', {
    staticClass: "flex f-col",
    staticStyle: {
      "width": "32rem"
    }
  }, [_c('div', {
    staticClass: "info-card"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "report"
  })]), _vm._v(" 基础情况 ")]), _c('div', {
    staticClass: "infos"
  }, [_c('div', {
    staticClass: "flex row-between"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("姓名")]), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.detail.patientName))])]), _c('div', {
    staticClass: "flex row-between"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("登记号")]), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.detail.patientID))])]), _c('div', {
    staticClass: "flex row-between"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("性别")]), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.detail.patientSex))])]), _c('div', {
    staticClass: "flex row-between"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("手机号")]), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.detail.patientPhone))])])])]), _c('div', {
    staticClass: "statistic mt flex"
  }, [_c('div', {
    staticClass: "icon"
  }), _c('div', {
    staticClass: "flex1 flex row-between"
  }, [_c('span', {
    staticClass: "tip"
  }, [_vm._v("预警指标：")]), _c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.detail.warnIItem) + " 次")])])]), _c('div', {
    staticClass: "statistic mt flex"
  }, [_c('div', {
    staticClass: "icon"
  }), _c('div', {
    staticClass: "flex1 flex row-between"
  }, [_c('span', {
    staticClass: "tip"
  }, [_vm._v("预警次数：")]), _c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.detail.warnNum) + " 人")])])]), _c('div', {
    staticClass: "statistic-bar"
  }), _c('div', {
    staticClass: "statistic flex"
  }, [_c('div', {
    staticClass: "icon"
  }), _c('div', {
    staticClass: "flex1 flex row-between"
  }, [_c('span', {
    staticClass: "tip"
  }, [_vm._v("电话随访次数：")]), _c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.detail.followUpNum) + " 人")])])]), _c('div', {
    staticClass: "statistic mt flex"
  }, [_c('div', {
    staticClass: "icon"
  }), _c('div', {
    staticClass: "flex1 flex row-between"
  }, [_c('span', {
    staticClass: "tip"
  }, [_vm._v("问卷随访次数：")]), _c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.detail.questionNum) + " 人")])])]), _c('div', {
    staticClass: "statistic-bar"
  }), _c('div', {
    staticClass: "statistic flex"
  }, [_c('div', {
    staticClass: "icon"
  }), _c('div', {
    staticClass: "flex1 flex row-between"
  }, [_c('span', {
    staticClass: "tip"
  }, [_vm._v("评估次数：")]), _c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.detail.assessNum) + " 人")])])]), _c('div', {
    staticClass: "statistic mt flex"
  }, [_c('div', {
    staticClass: "icon"
  }), _c('div', {
    staticClass: "flex1 flex row-between"
  }, [_c('span', {
    staticClass: "tip"
  }, [_vm._v("评估周期：")]), _c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.detail.assessCycle) + " 人")])])])])])])], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };